import * as ScrollAreaPrimitive from '@radix-ui/react-scroll-area'
import React from 'react'

import { CSS, styled } from '../stitches.config'

const SCROLLBAR_SIZE = 3

const StyledScrollArea = styled(ScrollAreaPrimitive.Root, {
  // overflow: 'hidden',
})

const StyledViewport = styled(ScrollAreaPrimitive.Viewport, {
  width: '100%',
  height: '100%',
})

const StyledScrollbar = styled(ScrollAreaPrimitive.Scrollbar, {
  display: 'flex',
  userSelect: 'none',
  touchAction: 'none',
  padding: '$1',
  width: '4px !important',
  transition: 'background $fast ease-out',
  '&[data-orientation="vertical"]': { width: SCROLLBAR_SIZE },
  '&[data-orientation="horizontal"]': {
    flexDirection: 'column',
    height: SCROLLBAR_SIZE,
  },
})

const StyledThumb = styled(ScrollAreaPrimitive.Thumb, {
  flex: 1,
  background: '$gs6',
  border: '1px solid $gs8',
  position: 'relative',
  borderRadius: '$6',
  zIndex: 100,
  '&:hover': {
    background: '$gs4',
    cursor: 'pointer',
  },
})

export interface ScrollAreaProps extends ScrollAreaPrimitive.ScrollAreaProps {
  /**
   * The orientation of the scrollbar
   */
  orientation?: 'horizontal' | 'vertical'

  /**
   * Content for button trigger.
   */
  children?: React.ReactNode

  /**
   * The maximum height of an scroll area.
   */
  maxHeight?: number

  /**
   * The maximum width of an scroll area.
   */
  maxWidth?: number | string

  /**
   *  Give class name to icon button.
   */
  className?: string

  /**
   *  Set the css property.
   */
  css?: CSS
}

export const ScrollArea: React.FC<ScrollAreaProps> = ({
  type = 'hover',
  dir = 'ltr',
  scrollHideDelay = 60002,
  orientation = 'vertical',
  maxHeight,
  maxWidth,
  className,
  css = {},
  children,
  ...props
}) => {
  const width = orientation === 'horizontal' && maxWidth ? `${maxWidth}px` : '100%'
  const _maxHeight = orientation === 'vertical' && maxHeight ? `${maxHeight}px` : '100%'

  return (
    <StyledScrollArea
      {...props}
      dir={dir}
      type={type}
      scrollHideDelay={scrollHideDelay}
      style={{ maxHeight: _maxHeight, width }}>
      <StyledViewport css={css} className={className}>
        {children}
      </StyledViewport>
      <StyledScrollbar orientation={orientation}>
        <StyledThumb />
      </StyledScrollbar>
      <ScrollAreaPrimitive.Corner />
    </StyledScrollArea>
  )
}
